module.exports = __webpack_public_path__ + "img/campanas.bb42a038.png";